export default __webpack_public_path__ + "static/media/6.14828157.png";